import axios from 'axios'
import { FetchProducerBySlugQuery, Producer } from 'types/producer'
import { stringify } from 'qs'
import { GetProducerBySlugResponse } from 'types/bolt-api/request'

/**
 * Get producer by slug
 *
 * @param {string} slug
 * @param {FetchProducerBySlugQuery} [params]
 * @returns {Promise<Producer | undefined>}
 */
const getProducerBySlug = async (slug: string, params?: FetchProducerBySlugQuery): Promise<Producer | undefined> => {
  try {
    const query = stringify(params, { addQueryPrefix: true, skipNulls: true })
    const { data } = await axios.get<GetProducerBySlugResponse>(`${process.env.API_URL}/producers/${slug}${query}`, {
      headers: {
        Authorization: `Basic ${process.env.API_TOKEN}`
      }
    })

    return data?.producer
  } catch (_) {
    return undefined
  }
}

export default getProducerBySlug
